import React from "react";
import { Check } from "lucide-react";
import { PRICING } from "../../config/site";
import { Reveal, useEnquiry } from "../../lib/site-ui";

export const Pricing = () => {
  const { openEnquiry } = useEnquiry();
  return (
    <section id="pricing" className="relative py-24 sm:py-32 lg:py-40 border-t border-white/10" data-testid="pricing-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-8">
        <div className="mb-14">
          <Reveal as="p" className="label-mono text-slate-500 mb-4">02 — Pricing</Reveal>
          <Reveal as="h2" className="font-display text-3xl sm:text-4xl lg:text-5xl tracking-tight text-white">
            Simple, Transparent Pricing
          </Reveal>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-px bg-white/10 border border-white/10">
          {/* Price block */}
          <Reveal className="lg:col-span-5 bg-slate-900 p-10 lg:p-12 flex flex-col justify-between">
            <div>
              <span className="inline-block label-mono text-slate-950 bg-white px-3 py-1.5 mb-8" data-testid="founding-badge">
                {PRICING.badge}
              </span>
              <p className="label-mono text-slate-400 mb-2">DGCA Ground Classes</p>
              <div className="flex items-end gap-2">
                <span className="font-display text-6xl lg:text-7xl text-white tracking-tighter" data-testid="pricing-amount">
                  {PRICING.currency}{PRICING.amount}
                </span>
                <span className="text-slate-400 mb-3 text-lg">{PRICING.unit}</span>
              </div>
              <p className="mt-5 text-slate-200 leading-relaxed max-w-sm">{PRICING.tagline}</p>
              <p className="mt-4 text-slate-400 leading-relaxed max-w-sm">{PRICING.note}</p>
            </div>
            <button
              data-testid="pricing-enquire-btn"
              onClick={() => openEnquiry({ message: "I'd like to know about the next batch." })}
              className="mt-10 bg-white text-slate-950 font-semibold px-8 py-4 rounded-sm hover:bg-slate-200 transition-all hover:scale-[1.02] text-sm tracking-wide w-full sm:w-auto"
            >
              ENQUIRE ABOUT A BATCH
            </button>
          </Reveal>

          {/* Includes */}
          <Reveal delay={0.1} className="lg:col-span-7 bg-slate-950 p-10 lg:p-12">
            <p className="label-mono text-slate-500 mb-8">What every subject includes</p>
            <ul className="grid grid-cols-1 sm:grid-cols-2 gap-y-5 gap-x-8">
              {PRICING.includes.map((item) => (
                <li key={item} className="flex items-center gap-3 text-slate-200">
                  <span className="grid place-items-center w-6 h-6 border border-white/15 rounded-full shrink-0">
                    <Check className="w-3.5 h-3.5 text-white" />
                  </span>
                  <span>{item}</span>
                </li>
              ))}
            </ul>
            <p className="mt-10 pt-8 border-t border-white/10 text-slate-500 text-sm leading-relaxed">
              Quality DGCA coaching made accessible. Our founding-batch price is designed to help serious aspiring
              pilots begin their preparation with proper guidance — not to cut corners on teaching.
            </p>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
